module.exports = __webpack_public_path__ + "img/FI01450193.e99b9d54.png";